<template>
    <div>
        <!-- [ Modal form Save Task Tree ] start -->
        <sweet-modal blocking ref="projectCashAdvanceModal" class="project-cash-advance-modal" v-on:close="closeModal">
            <h1 v-if='!ifEdit' class="project-cash-advance-modal__title">Request Cash Advance</h1>
            <h1 v-else class="project-cash-advance-modal__title">Edit Cash Advance</h1>
            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="130px" class="project-cash-advance-modal__form">
                <div>
                    <div>
                        <el-col class="col" :span="12">
                            <el-form-item v-if="ifEdit" label="Cash Advance No.">
                                <el-input disabled v-model="codeNo" filterable size="mini" placeholder="Cash Advance No.">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </div>
                    <el-row v-if="selectedRow">
                        <el-col :span="12">
                            <el-form-item prop="projectListName" :label="labelName">
                                <el-select :disabled="ifProjSelected" v-model="form.projectListId" size="mini" :placeholder="labelName">
                                    <el-option v-for="item in form.projectList"
                                               filterable
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id"
                                               @click.native="setProjId(item.id)">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="taskListId" label="Task">
                                <el-select :disabled="selectedRow.type === 'task' || selectedRow.type === 'masterTask' || disabledInputs" v-model="form.taskListId" clearable size="mini" placeholder="Task">
                                    <el-option v-for="item in form.taskList"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id"
                                               @click.native="setTaskId(item.id)">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <div>
                    <!--<el-row v-if="fromCashAdvancePage === true">-->
                        <!--<el-col :span="12">-->
                            <!--<el-form-item prop="projectListId" label="Project">-->
                                <!--<el-select v-model="form.projectListId" size="mini" placeholder="Project">-->
                                    <!--<el-option v-for="item in form.projectList"-->
                                               <!--:key="item.id"-->
                                               <!--:label="item.name"-->
                                               <!--:value="item.id"-->
                                               <!--@click.native="setProject(item.id)">-->
                                    <!--</el-option>-->
                                <!--</el-select>-->
                            <!--</el-form-item>-->
                        <!--</el-col>-->
                        <!--<el-col :span="12">-->
                            <!--<el-form-item  prop="taskListId" label="Task">-->
                                <!--<el-select clearable :disabled="disabledInputs" v-model="form.taskListId" size="mini" placeholder="Task">-->
                                    <!--<el-option v-for="item in form.taskList"-->
                                               <!--:key="item.id"-->
                                               <!--:label="item.name"-->
                                               <!--:value="item.id"-->
                                               <!--@click.native="setTask(item.id)">-->
                                    <!--</el-option>-->
                                <!--</el-select>-->
                            <!--</el-form-item>-->
                        <!--</el-col>-->
                    <!--</el-row>-->
                    <!--<el-row v-if="ifEdit === true">-->
                        <!--<el-col :span="12">-->
                            <!--<el-form-item prop="projectListIdEdit" label="Project">-->
                                <!--<el-select disabled v-model="form.projectListIdEdit" size="mini" placeholder="Project">-->
                                    <!--<el-option v-for="item in form.projectList"-->
                                               <!--:key="item.id"-->
                                               <!--:label="item.name"-->
                                               <!--:value="item.id"-->
                                               <!--@click.native="setProject(item.id)">-->
                                    <!--</el-option>-->
                                <!--</el-select>-->
                            <!--</el-form-item>-->
                        <!--</el-col>-->
                        <!--<el-col :span="12">-->
                            <!--<el-form-item  prop="taskListIdEdit" label="Task">-->
                                <!--<el-select  :disabled="disabledInputs" clearable v-model="form.taskListIdEdit" size="mini" placeholder="Task">-->
                                    <!--<el-option v-for="item in form.taskList"-->
                                               <!--:key="item.id"-->
                                               <!--:label="item.name"-->
                                               <!--:value="item.id"-->
                                               <!--@click.native="setTask(item.id)">-->
                                    <!--</el-option>-->
                                <!--</el-select>-->
                            <!--</el-form-item>-->
                        <!--</el-col>-->
                    <!--</el-row>-->
                </div>
                <el-row>
                    <el-col :span="12">
                        <el-form-item prop="companyInventoryItemId" label="Expense Item">
                            <el-select :disabled="disabledInputs" v-model="form.companyInventoryItemId" filterable size="mini" placeholder="Expense Item">
                                <el-option
                                        v-for="item in form.companyInventoryItem"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="paymentMethodId" label="Payment Method">
                            <el-select :disabled="disabledInputs" v-model="form.paymentMethodId" size="mini" placeholder="Payment Method">
                                <el-option
                                        v-for="item in form.paymentMethodList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="Date" prop="date">
                            <el-date-picker
                                    format="d MMM yy"
                                    :disabled="disabledInputs"
                                    size="mini"
                                    v-model="form.date"
                                    type="date"
                                    placeholder="Pick a date"
                                    value-format="ddMMyyyy"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="clientId" label="Client">
                            <el-select :disabled="disabledInputs" v-model="form.clientId" filterable size="mini" placeholder="Client">
                                <el-option
                                        v-for="item in form.clientList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item   prop="amount" label="Amount">
                            <el-input :disabled="disabledInputs" type="number" v-model="form.amount" size="mini" placeholder="Amount"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="groupTripName" label="Group / Trip Name">
                            <el-input :disabled="disabledInputs" v-model="form.groupTripName" size="mini" placeholder="Group / Trip Name"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!--<el-row>-->
                    <!--<el-col :span="12">-->
                        <!--<el-form-item label="Add Expenses">-->
                            <!--<el-switch-->
                                    <!--v-model="form.addExpense">-->
                            <!--</el-switch>-->
                        <!--</el-form-item>-->
                    <!--</el-col>-->
                    <!--<el-col :span="12">-->
                        <!--<el-form-item label="Total Amount :">-->
                            <!--<el-button size="mini" type="primary" >{{totalAmaunt}}</el-button>-->
                        <!--</el-form-item>-->
                    <!--</el-col>-->
                <!--</el-row>-->
                <!--<el-row :span="24" v-if="form.addExpense">-->
                    <!--<el-form-item label="Choose Expenses">-->
                    <!--<el-select-->
                            <!--size="mini"-->
                            <!--v-model="form.expenseListId"-->
                            <!--multiple-->
                            <!--filterable-->
                            <!--placeholder="Choose Expenses">-->
                        <!--<el-option-->
                                <!--v-for="item in form.expenseList"-->
                                <!--:key="item.id"-->
                                <!--:label="item.code + ' total amount: ' + item.totalAmount"-->
                                <!--:value="item.id">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                    <!--</el-form-item>-->
                <!--</el-row>-->
                <el-row>
                    <el-form-item label="Notes" prop="notes">
                        <el-input :disabled="disabledInputs" type="textarea" v-model="form.notes"></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <addFileToExpence :fileListEdit="fileListEdit" :disabledInputs="disabledInputs" ref="addFileToExpence" :selectedRow="selectedRow" @nestedChildOpen="nestedChildOpen" @putFileIntoFormArray="putFileIntoFormArray" @removeFile="removeFile" />
                </el-row>
                <div class="project-cash-advance-modal__btn">
                    <!--<el-button @click="click()">clik</el-button>-->
                    <el-button v-if="ifEdit === false" :disabled="disabledInputs" @click="submitForm('form', activeState)" type="primary" plain size="mini">Save</el-button>
                    <el-button v-else :disabled="disabledInputs" @click="submitFormEdit('form', activeState)" type="primary" plain size="mini">Edit</el-button>
                </div>
            </el-form>
        </sweet-modal>
        <!-- <sweet-modal class="nested" ref="nestedChild">
            <iframe class="iframe" :src="'https://docs.google.com/gview?url=' + fileUrl + '&embedded=true'" frameborder="0"></iframe>
        </sweet-modal> -->
    </div>
</template>

<script>
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import addFileToExpence from '@/components/Projects/addFileToExpence.vue'

  import axios from 'axios'
  let moment = require('moment')

  export default {
    components: {
      SweetModal,

      addFileToExpence
    },
    props: ['selectedRow'],
    data() {
      return {
        ifEdit:false,
        ifProjSelected: true,
        codeNo: '',
        fromCashAdvancePage: false,
        disabledInputs:true,
        // totalAmaunt: 0,
        fileListEdit: [],
        fileUrl: '',
        form: {
          projectListIdEdit:'',
          projectListId: '',
          projectList:[],
          // taskListIdEdit: '',
          taskListId: '',
          taskList: [],
          addExpense: false,
          companyInventoryItemId: '',
          companyInventoryItem: [],
          // expenseListId: '',
          // expenseList: [],
          date:'',
          paymentMethodId: '',
          paymentMethodList: [],
          amount: '',
          clientId: '',
          clientList: [],
          groupTripName: '',
          notes: '',
          fileId: null
        },
        rules: {
          companyInventoryItemId: [{
            required: true,
            message: 'Field is required',
            trigger: 'blur'
          }],
          amount: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          date: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          paymentMethodId: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          clientId: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          notes:[
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          projectListId: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ]
        },
        projectCashAdvanceId: '',
        labelName: '',
        activeState: ''
      }
    },
    // mounted(){
    //   this.links = this.loadAll();
    // },
    methods: {
      openModal(state, projectId){
        this.activeState = state
        const urlParts = this.buildUrl(state)
        this.labelName = urlParts.labelName
        console.log('urlParts', urlParts)
        return new Promise((resolve, reject) => {
          if(this.selectedRow){
            this.disabledInputs = false
            if(this.selectedRow.type ==='task' || this.selectedRow.type ==='masterTask'){
              this.form.taskListId = this.selectedRow.id
            }
          }
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/${urlParts.state}/directories?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${this.$route.query.projectId || this.$route.query.engagementId|| this.$route.query.businessUnitId || projectId}&${urlParts.stateTaskId}=${this.selectedRow.id || this.$route.query.taskId || 0}`)
            .then(response => {
              loader.hide()
              if(this.$route.name === 'projects'){
                this.form.projectListId = response.data.project[0].id;
                this.form.projectList = response.data.project;
              }
              var index = this.find(response.data.projectTask, this.form.taskListId);
              console.log('index', index)
              if(!index){
                this.form.taskListId = ''
              }
              this.form.taskList = response.data.projectTask;
              this.form.companyInventoryItem = response.data.companyInventoryItem;
              this.form.paymentMethodList = response.data.projectTaskExpensePaymentMethod;
              this.form.clientList = response.data.companyClientList;
              this.$refs.projectCashAdvanceModal.open()
              console.log('---', response.data);
              resolve('ok')
            }).catch(err => {
            loader.hide()
            reject('no')
            console.log('---', err);
          })
        })
      },
      openModalFromCashAdvance(state){
        console.log('mySatte open modal', state)
        this.activeState = state
        this.fromCashAdvancePage = true
        this.ifProjSelected = false

        const urlParts = this.buildUrl(state)
        this.labelName = urlParts.labelName
        this.getProjectList(urlParts.routeName)
      },
      openModalFromCashAdvanceEdit(selectedRow, state){

        const urlParts = this.buildUrl(state)
        this.labelName = urlParts.labelName

        this.activeState = state
        this.ifEdit = true
        this.disabledInputs = false
        console.log('selectedRow cashAdvance', selectedRow)
        this.form.projectListId = selectedRow.projectId
        this.form.projectList = [selectedRow.project]
        this.form.taskListId = selectedRow.projectTaskId
        this.openModal(state, selectedRow.projectId).then(resp => {
          if(resp === 'ok'){
            this.getItem(selectedRow.projectId, selectedRow.projectTaskId, selectedRow.id, state)
            console.log('selectedRow.projectId, selectedRow.projectTaskId, selectedRow.id', selectedRow.projectId, selectedRow.projectTaskId, selectedRow.id)
          }
        })
        // this.form.projectListIdEdit = selectedRow.project.name
        // if(!selectedRow.projectTaskId){
        //   this.form.taskListIdEdit = ''
        // }else{
        //   this.form.taskListIdEdit = selectedRow.projectTaskId
        // }
        // this.setProject(selectedRow.projectId, selectedRow.projectTaskId, selectedRow.id, 'update')
        // this.setTask(selectedRow.projectTaskId)
        // this.$refs.projectCashAdvanceModal.open()
      },
      getItem(projectId, projectTaskId, projectCashAdvanceId, state){
        this.projectCashAdvanceId = projectCashAdvanceId
        if(projectTaskId === null){
          projectTaskId = 0
        }
        const urlParts = this.buildUrl(state)

        // let stateProjectId = ''
        // let stateTaskId = ''
        // let stateCashAdvanceId = ''
        // switch (state){
        //   case 'projectTasksCashAdvance':
        //     stateProjectId = 'projectId'
        //     stateTaskId = 'projectTaskId'
        //     stateCashAdvanceId = 'projectTaskCashAdvanceId'
        //     break;
        //   case 'engagementTasksCashAdvance':
        //     stateProjectId = 'engagementId'
        //     stateTaskId = 'engagementTaskId'
        //     stateCashAdvanceId = 'engagementTaskCashAdvanceId'
        //     break;
        //   case 'businessUnitTasksCashAdvance':
        //     stateProjectId = 'businessUnitId'
        //     stateTaskId = 'businessUnitTaskId'
        //     stateCashAdvanceId = 'businessUnitTaskCashAdvanceId'
        //     break;
        // }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.state}/item?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}&${urlParts.stateTaskId}=${projectTaskId}&${urlParts.stateCashAdvanceId}=${projectCashAdvanceId}`)
          .then(response => {
            this.codeNo = response.data.item.code
            if(response.data.item.projectTaskId === 0){
              this.form.taskListId = null
            }else{
              this.form.taskListId = response.data.item.projectTaskId
            }
            this.form.companyInventoryItemId = response.data.item.projectTaskExpenseInventoryItemId
            this.form.paymentMethodId = response.data.item.projectTaskExpensePaymentMethodId
            let date = response.data.item.cashAdvanceDate.toString()
            if (date.length < 8) {
              date = '0' + date
            }
            this.form.date = date
            this.form.clientId = response.data.item.companyClientId
            this.form.amount = response.data.item.amount
            this.form.groupTripName = response.data.item.group
            this.form.notes = response.data.item.notes
            this.form.fileId = response.data.item.fileId
            if(response.data.item){
              let newFileItem = {
                id: '',
                name: '',
                url: ''
              }
              newFileItem.id = response.data.item.file.id
              newFileItem.name = response.data.item.file.baseName
              newFileItem.url = response.data.item.file.url
              this.fileListEdit.push(newFileItem)
            }
          }).catch(error =>{

        })
      },
      getProjectList(state){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${state}/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.form.projectList = response.data.list
            this.$refs.projectCashAdvanceModal.open()
          }).catch(error =>{

        })
      },
      submitForm(form, state) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            let data = {
              projectTaskExpenseInventoryItemId: this.form.companyInventoryItemId,
              projectTaskExpensePaymentMethodId: this.form.paymentMethodId,
              companyClientId: this.form.clientId,
              expenseDate: this.form.date,
              amount: this.form.amount,
              group: this.form.groupTripName,
              notes: this.form.notes,
              fileId: this.form.fileId,
            }
            const urlParts = this.buildUrl(state)
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/${urlParts.state}/create?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${this.form.projectListId}&${urlParts.stateTaskId}=${this.form.taskListId || 0}`, data)
              .then(response => {
                if(this.$route.name === 'cash-advances' || this.$route.name === 'users'){
                  this.$emit('setValueProject', this.form.projectListId);
                }
                this.notification("Success", "Added Cash Advance", "success");
                this.$refs.projectCashAdvanceModal.close()
                document.body.removeAttribute('style')
              }).catch(error =>{
              this.$refs.projectCashAdvanceModal.close()
              document.body.removeAttribute('style')
              console.log(error)
            })
          }
        })
      },
      submitFormEdit(form, state) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            let data = {
              projectTaskExpenseInventoryItemId: this.form.companyInventoryItemId,
              projectTaskExpensePaymentMethodId: this.form.paymentMethodId,
              companyClientId: this.form.clientId,
              expenseDate: this.form.date,
              amount: this.form.amount,
              group: this.form.groupTripName,
              notes: this.form.notes,
              fileId: this.form.fileId,
            }
            if(!data.fileId){
              data.fileId = null
            }
            const urlParts = this.buildUrl(state)
            // let stateProjectId = ''
            // let stateTaskId = ''
            // let stateCashAdvanceId = ''
            // switch (state){
            //   case 'projectTasksCashAdvance':
            //     stateProjectId = 'projectId'
            //     stateTaskId = 'projectTaskId'
            //     stateCashAdvanceId = 'projectTaskCashAdvanceId'
            //     break;
            //   case 'engagementTasksCashAdvance':
            //     stateProjectId = 'engagementId'
            //     stateTaskId = 'engagementTaskId'
            //     stateCashAdvanceId = 'engagementTaskCashAdvanceId'
            //     break;
            //   case 'businessUnitTasksCashAdvance':
            //     stateProjectId = 'businessUnitId'
            //     stateTaskId = 'businessUnitTaskId'
            //     stateCashAdvanceId = 'businessUnitTaskCashAdvanceId'
            //     break;
            // }
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            let projectId = ''
            if(this.$route.name === 'cash-advances' || this.$route.name === 'users'){
              projectId = this.form.projectListId
            }
            axios
              .post(`/api/v1/${urlParts.state}/update?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}&${urlParts.stateTaskId}=${this.form.taskListId || 0}&${urlParts.stateCashAdvanceId}=${this.projectCashAdvanceId}`, data)
              .then(response => {
                if(this.$route.name === 'cash-advances' || this.$route.name === 'users'){
                  this.$emit('setValueProject', this.form.projectListId);
                }
                this.$refs.projectCashAdvanceModal.close();
                this.notification("Success", "Edit Cash Advance", "success");
              }).catch(error => {
              console.log('An error occurred:', error);
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      // click(){
      //   this.closeModal()
      // },
      setProjId(projectId){
        this.disabledInputs = false
        this.openModal(this.activeState, projectId)
      },
      setTask(){
        console.log('set Task')
      },
      setTaskId(taskId){
        console.log('taskId', taskId)
      },
      removeFile(){
        console.log('remove file')
      },
      putFileIntoFormArray(fileId){
        console.log('putFileIntoFormArray')
          this.form.fileId = fileId
      },
      nestedChildOpen(){
        console.log('nestedChildOpen')
      },
      getTotalAmount(){
        console.log('getTotalAmount')
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      find(array, value) {
        for (var i = 0; i < array.length; i++) {
          console.log(array[i].id + '/' + value)
          if (array[i].id == value) return true;
        }
        return false
      },
      buildUrl(state) {
        let stateProjectId = ''
        let stateTaskId = ''
        let stateCashAdvanceId = ''
        let routeName = ''
        let labelName = ''
        // switch (advanceTab) {
        //   case 'tasksCashAdvance':
        switch (state){
          case 'projectTasksCashAdvance':
            stateProjectId = 'projectId'
            stateTaskId = 'projectTaskId'
            stateCashAdvanceId = 'projectTaskCashAdvanceId'
            routeName = 'projects'
            labelName = 'Project'
            break;
          case 'engagementTasksCashAdvance':
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateCashAdvanceId = 'engagementTaskCashAdvanceId'
            routeName = 'engagements'
            labelName = 'Engagements'
            break;
          case 'businessUnitTasksCashAdvance':
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateCashAdvanceId = 'businessUnitTaskCashAdvanceId'
            routeName = 'businessUnits'
            labelName = 'Business Units'
            break;
          case 'requestProjectTasksCashAdvance':
            stateProjectId = 'projectId'
            stateTaskId = 'projectTaskId'
            stateCashAdvanceId = 'projectTaskCashAdvanceId'
            routeName = 'projects'
            labelName = 'Project'
            break;
          case 'requestEngagementTasksCashAdvance':
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateCashAdvanceId = 'engagementTaskCashAdvanceId'
            routeName = 'engagements'
            labelName = 'Engagements'
            break;
          case 'requestBusinessUnitTasksCashAdvance':
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateCashAdvanceId = 'businessUnitTaskCashAdvanceId'
            routeName = 'businessUnits'
            labelName = 'Business Units'
            break;
        }
        //     break;
        // }
        return { state: state, stateProjectId: stateProjectId, stateTaskId: stateTaskId, stateCashAdvanceId: stateCashAdvanceId, routeName: routeName, labelName: labelName}
      },
      closeModal() {
        this.$refs['addFileToExpence'].fileList = []
        this.form.projectListIdEdit = '';
        this.form.projectListId = '';
        this.form.projectList = [];
        // this.form.taskListIdEdit = '';
        this.form.taskListId = '';
        this.form.taskList = [];
        this.form.companyInventoryItemId = '';
        this.form.companyInventoryItem = [];
        this.form.date = '';
        this.form.paymentMethodId =  '';
        this.form.paymentMethodList = [];
        this.form.amount = '';
        this.form.clientId = '';
        this.form.clientList = [];
        this.form.groupTripName = '';
        this.form.notes = '';
        this.form.fileId = null;
        this.disabledInputs = true;
        this.fromCashAdvancePage = false
        this.ifEdit = false;
        this.fileListEdit = [];
        // this.totalAmaunt = 0;
        // this.form.addExpense = false;
        this.form.expenseListId = '';
        this.form.expenseList = [];
        this.$refs['form'].resetFields();
        this.labelName = '';
        this.activeState = ''
      },
    },
  }
</script>

<style lang="scss" scoped>
    .project-cash-advance-modal {
        &__title {
            text-align: center;
        }
        &__btn {
            text-align: center;
        }
        .form-row{
            display:flex;
            justify-content:space-around;
        }
        &__form{

        }
        .el-form-item {
            margin-bottom: 18px;
        }
        /deep/.el-form-item__label{
            line-height:18px;
        }
        /deep/.el-form-item__content{
            line-height:18px;
        }
        .el-select {
            display: block;
        }
        .el-date-editor{
            width:100%;
        }
        .inclusive-btn{
            margin-bottom:18px;
        }
        /deep/.el-input.is-disabled .el-input__inner{
            color: #404348;
        }
    }
    /deep/.el-upload{
        width:100%;
    }
    /deep/.el-upload-dragger{
        min-width:100%;
    }
    .amount-input{
        /deep/.el-input__inner{
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }
    }
    .amount-currency{
        /deep/.el-input__inner{
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }
    .iframe{
        width:640px;
        height:700px;
    }
    .sweet-modal-overlay{
        z-index:1000;
    }
    /deep/.el-autocomplete{
        width:100%;
        .el-input-group__append{
            background-color: #ecf5ff;
            color: #409EFF;
            border-color: #b3d8ff;
            &:hover{
                background: #409EFF;
                border-color: #409EFF;
                color: #FFF;
            }
        }
        /*.el-input__suffix{*/
        /*right:0;*/
        /*.add-btn{*/

        /*}*/
        /*i{*/
        /*display:none;*/
        /*}*/
        /*}*/
    }
    .col{
        margin-left:50%;
    }
</style>

<style>

</style>
